import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Card, Row, Col, Skeleton, Button, message, Modal, Icon, Popover, Spin, Table, Radio } from 'antd';
import moment from 'moment';
import { pick } from 'lodash';

import { api } from '../../../../../services';

import EssentialIcon from '../../../../../common/icons/EssentialIcon';
import DateTimePicker from '../../../../../common/components/DateTimePicker';

import PromptModal from '../../../../../common/components/PromptModal';

import './ReservationsCard.css';

const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;

@inject('translationsStore', 'commonStore')
@observer
export default class ReservationsCard extends Component {
  constructor(props) {
    super(props);

    this.PromptModal = React.createRef();

    this.DateTimePicker = React.createRef();

    const { commonStore } = this.props;
    this.historyTableColumns = {
      reservations: [
        {
          dataIndex: 'reservationDate',
          title: this.props.translationsStore.translate('carView.reservations.history.table.columns.reservationDate'),
          sorter: true,
          sortOrder: false,
          render: text => moment(text).format(commonStore.longDateFormat.LLL)
        },
        {
          dataIndex: 'status',
          title: this.props.translationsStore.translate('carView.reservations.history.table.columns.status'),
          sorter: true,
          sortOrder: false,
          render: text => <span className={text === 'booked' ? 'green' : 'red'}>{this.props.translationsStore.translate(`carView.reservations.statuses.${text}`)}</span>
        }
      ],
      rejections: [
        {
          dataIndex: 'discardDate',
          title: this.props.translationsStore.translate('carView.reservations.history.table.columns.discardDate'),
          sorter: true,
          sortOrder: false,
          render: text => moment(text).format(commonStore.longDateFormat.LLL)
        },
        {
          dataIndex: 'closeOrDiscardReason',
          title: this.props.translationsStore.translate('carView.reservations.history.table.columns.closeOrDiscardReason'),
          sorter: true,
          sortOrder: false
        }
      ]
    };
    this.historyFetchMethods = [
      {
        key: 'reservations',
        method: 'getReservationsHistory',
        defaultSorter: { field: 'reservationDate', order: 'DESC' }
      },
      {
        key: 'rejections',
        method: 'getLeadHistory',
        defaultSorter: { field: 'reservationDate', order: 'DESC' }
      }
    ];

    this.state = {
      reservations: [],

      sorters: { reservations: this.historyFetchMethods[0].defaultSorter, rejections: this.historyFetchMethods[1].defaultSorter }
    };
  }

  componentDidMount = () => {
    this.PromptModalInstance = this.PromptModal.current;
    message.config({
      getContainer: () => document.getElementById('ReservationsCard')
    });
    this.DateTimePickerInstance = this.DateTimePicker.current.wrappedInstance;
  };

  componentWillUnmount = () => {
    message.destroy();
  };

  formatAsTime = datetime => moment(datetime).format(this.props.commonStore.longDateFormat.LT);
  formatAsDate = datetime => moment(datetime).format(this.props.commonStore.longDateFormat.L);

  reservation = (reservation, index) => (
    <Row key={index} type="flex" style={{ marginBottom: '5px', justifyContent: 'space-between', alignItems: 'center' }} className="reservation">
      <Row type="flex">
        <Col style={{ paddingRight: '5px' }}>
          <EssentialIcon type="calendar-1" />
        </Col>
        <Col>{this.formatAsDate(reservation.reservationDate)}</Col>
        <Col style={{ padding: '0 5px' }}>
          <EssentialIcon type="clock-1" />
        </Col>
        <Col>{this.formatAsTime(reservation.reservationDate)}</Col>
      </Row>
      <Row type="flex" className="buttons">
        <Icon type="edit" theme="outlined" onClick={this.updateReservation(reservation)} style={{ cursor: 'pointer', marginRight: '5px' }} />
        <Icon type="delete" theme="outlined" onClick={this.showDeleteReservationConfirm(reservation)} style={{ cursor: 'pointer' }} />
      </Row>
    </Row>
  );

  callAction = (action, ...params) => {
    const { translationsStore } = this.props;
    this.setState({ updatingReservations: true });
    return api(`${action} reservation`, ...params).then(response => {
      this.setState({ updatingReservations: false });
      if (response.success === true) {
        message.success(translationsStore.translate(`carView.reservations.${action}.success`));
        this.props.onChange();
      } else {
        message.error(translationsStore.translate(`carView.reservations.${action}.error`));
      }
    });
  };

  updateReservation = reservation => () => {
    const { translationsStore } = this.props;
    this.DateTimePickerInstance.setDatetime(reservation.reservationDate);
    const onOk = dateTime => {
      this.DateTimePickerInstance.close();
      this.callAction('update', reservation.id, dateTime);
    };
    this.setState({
      dateTimePickerOnOk: onOk,
      dateTimePickerTitle: (
        <Row>
          <Col>{translationsStore.translate('carView.reservations.update.title')}</Col>
          <Col>
            {translationsStore.translate('carView.reservations.currentReservation')}: {this.formatAsDate(reservation.reservationDate)}{' '}
            {translationsStore.translate('carView.reservations.at')} {this.formatAsTime(reservation.reservationDate)}
          </Col>
        </Row>
      )
    });
    this.DateTimePickerInstance.open();
  };

  showDeleteReservationConfirm = reservation => () => {
    Modal.confirm({
      title: this.props.translationsStore.translate('carView.reservations.delete.confirmation.title'),
      content: this.props.translationsStore.translate('carView.reservations.delete.confirmation.content'),
      onOk: () => {
        this.deleteReservation(reservation);
      }
    });
  };

  deleteReservation = reservation => {
    this.callAction('delete', reservation.id);
  };

  addReservation = () => {
    this.DateTimePickerInstance.setDatetime();
    const onOk = dateTime => {
      this.DateTimePickerInstance.close();
      this.callAction('add', this.props.leadId, this.props.carId, dateTime);
    };
    this.setState({ dateTimePickerOnOk: onOk, dateTimePickerTitle: this.props.translationsStore.translate('carView.reservations.add.title') });

    this.DateTimePickerInstance.open();
  };

  modalSuccess = (title = this.props.translationsStore.translate('carView.CommunicationCard.modal.success')) =>
    Modal.success({
      title
    });

  clientReject = reason => {
    api('client discard', reason, this.props.leadId).then(response => {
      if (response.success === true) {
        this.props.onChange();
        this.modalSuccess();
      }
    });
  };

  openDiscardModal = () => {
    const title = this.props.translationsStore.translate('carView.CommunicationCard.modal.title.discard');
    const content = this.props.translationsStore.translate('carView.CommunicationCard.modal.content.discard');
    this.PromptModalInstance.open({ title, onOk: this.clientReject, textarea: true, content });
  };

  loadHistory = (methods = ['reservations', 'rejections'], page = 1) => {
    this.setState({
      historyLoading: true
    });
    const { carId } = this.props;
    const { sorters } = this.state;
    Promise.all(
      methods.map(method => {
        const { field: sort, order } = sorters[method];
        return api(this.historyFetchMethods.find(helper => helper.key === method).method, carId, page, sort, order);
      })
    ).then(methodsResponse => {
      const historySum = !!this.state.historySum
        ? this.state.historySum
        : methods.reduce((accumulator, method, index) => {
            return accumulator + methodsResponse[index].count;
          }, 0);
      let computedResources = methodsResponse.map((response, index) => ({
        key: methods[index],
        count: response.count,
        page,
        dataSource: response.rows.map((row, index) => ({
          ...row,
          key: index
        })),
        pagination: { total: response.count, current: page }
      }));
      let definedResources = this.state.historyResources;
      if (definedResources) {
        definedResources = definedResources.map(item => {
          const resource = computedResources.find(resource => resource.key === item.key);
          return resource ? resource : item;
        });
      } else {
        definedResources = computedResources;
      }

      const historyActiveKey = definedResources.reduce((accumulator, currentValue) => {
        return accumulator === null && methods.findIndex(method => method === currentValue.key) > -1 && currentValue.count > 0 ? currentValue.key : accumulator;
      }, null);

      let historyData = {
        historyLoading: false,
        historySum: historySum,
        historyResources: definedResources,
        historyActiveKey
      };

      if (historySum !== 0) {
        historyData = { ...historyData, historyShow: true, historyNoDataHint: false };
      } else {
        historyData = { ...historyData, historyShow: false, historyNoDataHint: true };
      }
      this.setState(historyData);
    });
  };

  switchHistory = e => {
    this.loadHistory([e.target.value]);
  };

  handleTableChange = (key, pagination, filters, sorter) => {
    const { current: page } = pagination;
    const sorterVal = pick(sorter, ['field', 'order']);
    sorterVal.order = sorterVal.order === 'descend' ? 'DESC' : 'ASC';
    this.setState({ sorters: { ...this.state.sorters, [key]: sorterVal } }, () => {
      this.loadHistory([key], page);
    });
  };

  render() {
    const { translationsStore } = this.props;
    const { sorters, historyActiveKey } = this.state;

    const historySwitch = this.historyFetchMethods.filter(item => ((this.state.historyResources || []).find(helper => helper.key === item.key) || {}).count > 0);
    let columns = this.historyTableColumns;
    if (!Array.isArray(columns)) {
      columns = this.historyTableColumns[historyActiveKey] || [];
    }
    columns = columns.map(column => {
      let sortOrder = (sorters[historyActiveKey] || {}).field === column.dataIndex ? sorters[historyActiveKey].order : false;
      sortOrder = sortOrder === 'DESC' ? 'descend' : sortOrder === 'ASC' ? 'ascend' : false;
      return {
        ...column,
        sortOrder
      };
    });

    return (
      <Card className="ReservationsCard" id="ReservationsCard" style={this.props.style} bodyStyle={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
        <div className="header">
          <div>{translationsStore.translate('carView.reservations.title')}</div>
          <Popover
            content={translationsStore.translate('carView.reservations.historyNoData.message')}
            title={translationsStore.translate('carView.reservations.historyNoData.title')}
            trigger="click"
            visible={this.state.historySum === 0 && this.state.historyNoDataHint}
            onVisibleChange={visible => this.setState({ historyNoDataHint: visible })}
          >
            <Button onClick={() => this.loadHistory()} type="primary">
              {translationsStore.translate('carView.history')}
            </Button>
          </Popover>
        </div>
        <Skeleton loading={this.props.loading || this.state.updatingReservations}>
          <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', flex: 'auto' }}>
            <Row className="body">
              {(!this.props.reservations || this.props.reservations.length === 0) && <Col>{translationsStore.translate('carView.reservations.noreservations')}</Col>}
              {!!this.props.reservations && this.props.reservations.length > 0 && this.props.reservations.map(this.reservation)}
              {!!this.props.otherreservations && this.props.otherreservations.length > 0 && (
                <a onClick={() => this.setState({ showModal: true })}>
                  {translationsStore.translate('carView.reservations.otherreservations.message')} ({this.props.otherreservations.length})
                </a>
              )}
            </Row>

            <Row type="flex" className="footer">
              <Button type="primary" onClick={this.addReservation}>
                {translationsStore.translate('carView.reservations.actions.book')}
              </Button>
              <Button type="warning" className="discarded" onClick={this.openDiscardModal}>
                <EssentialIcon type="discarded" />
                {translationsStore.translate('carView.CommunicationCard.discard')}
              </Button>
            </Row>
          </div>
        </Skeleton>
        <DateTimePicker title={this.state.dateTimePickerTitle} ref={this.DateTimePicker} onOk={this.state.dateTimePickerOnOk} />
        <PromptModal ref={this.PromptModal} />
        <Modal
          title={translationsStore.translate('carView.reservations.otherreservations.title')}
          getContainer={() => document.getElementById('ReservationsCard')}
          visible={this.state.showModal}
          onCancel={() => this.setState({ showModal: false })}
          footer={null}
        >
          {!!this.props.otherreservations && <Row className="body">{this.props.otherreservations.map(this.reservation)}</Row>}
        </Modal>
        <Modal
          title={translationsStore.translate('carView.reservations.history.title')}
          width="calc(var(--tablet-width) / var(--modal-width-ratio))"
          visible={this.state.historyShow}
          getContainer={() => document.getElementById('ReservationsCard')}
          footer={null}
          onCancel={() => this.setState({ historyShow: false })}
          centered={true}
        >
          <Spin spinning={this.state.historyLoading}>
            <div style={{ marginBottom: 20 }}>
              {historySwitch.length > 1 && (
                <RadioGroup onChange={this.switchHistory} defaultValue={historySwitch[0].key}>
                  {historySwitch.map((item, index) => (
                    <RadioButton key={index} value={item.key}>
                      {translationsStore.translate(`carView.reservations.history.panels.${item.key}`)}
                    </RadioButton>
                  ))}
                </RadioGroup>
              )}
            </div>
            {(this.state.historyResources || []).map(
              (item, index) =>
                item.count > 0 &&
                item.key === this.state.historyActiveKey && (
                  <Table
                    key={index}
                    dataSource={this.state.historyResources[index] && this.state.historyResources[index].dataSource}
                    columns={columns}
                    pagination={item.pagination}
                    onChange={(...params) => this.handleTableChange(item.key, ...params)}
                  />
                )
            )}
          </Spin>
        </Modal>
      </Card>
    );
  }
}
